import React from 'react';

export const PlaytimeMediumIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="53"
            version="1.1"
            viewBox="0 0 5.821 14.023"
        >
            <g strokeWidth="0.529">
                <rect
                    width="5.292"
                    height="13.494"
                    x="0.265"
                    y="0.265"
                    fill="none"
                    stroke="#fff"
                    ry="1.349"
                ></rect>
                <path
                    fill="#fff"
                    fillOpacity="1"
                    stroke="none"
                    d="M0.794 7.144H5.026999999999999V10.054H0.794z"
                ></path>
                <path
                    fill="#fff"
                    fillOpacity="1"
                    stroke="none"
                    d="M1.69 13.23a.894.894 0 01-.896-.896V10.319H5.027V12.334c0 .496-.4.895-.895.895z"
                ></path>
            </g>
        </svg>
    );
};
